/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EquipmentScheduleDeviceIssuesResponse } from './equipment-schedule-device-issues-response';


export interface PreviewEquipmentScheduleAssignmentsResponse { 
    newCount?: number;
    alreadyAssignedCount?: number;
    conflictCount?: number;
    warningCount?: number;
    devices?: Array<EquipmentScheduleDeviceIssuesResponse> | null;
}

